import { AppState } from '../types/store';
import {
  getFeedTypeSubnavigation,
  getThisUser,
  getCurrentPageType,
} from './page';
import {
  getIsCurrentStreamEmpty,
  getCurrentPage,
  getHasMore,
  getInitialOffset,
  getPageSize,
} from './stream';
import { getPageUrl } from '../helpers/getPageUrl';
import {
  getPagingMode,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession/selectors';

export function getShouldShowFooter(state: AppState): boolean {
  if (!getIsMobile(state) && getPagingMode(state) !== 'scroll') {
    return true;
  }

  // Show footer in case of no results
  return getIsCurrentStreamEmpty(state);
}

interface RelatedSeoNavigation {
  next?: string;
  prev?: string;
}
/** Creates a pair of urls for use in link rel="next/prev" and SEO
 *  metadata relative to the current content
 *  https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types */
export function getRelatedSeoNavigation(state: AppState): RelatedSeoNavigation {
  let currentPage = getCurrentPage(state);
  currentPage = typeof currentPage !== 'undefined' ? currentPage : 0;
  const hasMore = getHasMore(state);
  const requestUrl = state.environment.requestUrl;

  return {
    next: hasMore ? getPageUrl(currentPage + 1, requestUrl) : undefined,
    prev: currentPage > 0 ? getPageUrl(currentPage - 1, requestUrl) : undefined,
  };
}

/** Gets the page a given offset would fall on based on page size */
export function getPageForOffset(state: AppState, offset: number): number {
  const initialOffset = getInitialOffset(state);
  const pageSize = getPageSize(state);
  return Math.floor((offset + initialOffset) / pageSize) + 1;
}

export function getShowNetworkBarInSiteHeader(state: AppState) {
  return ['search', 'tag', 'topic'].includes(
    state.currentPageData?.pageType ?? 'home'
  );
}

export function getSelectedNetworkBarItem(state: AppState) {
  if (state.currentPageData?.pageType === 'groups') {
    return state.currentPageData?.thisGroup;
  }

  return state.currentPageData?.pageType;
}

export function getShouldMarkSelectedNetworkBarItemAsRead(state: AppState) {
  // single user watch pages do not mark the networkbar itself read
  if (getCurrentPageType(state) === 'watch' && !!getThisUser(state)) {
    return false;
  }

  const nav = getFeedTypeSubnavigation(state);

  return nav?.options?.every(
    option => option.subnav === nav?.currentValue || !option.hasNewContent
  );
}
